import { render, staticRenderFns } from "./DunningEmailRates.vue?vue&type=template&id=3111bb53&"
import script from "./DunningEmailRates.vue?vue&type=script&lang=ts&"
export * from "./DunningEmailRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports